export default __webpack_public_path__ + "static/scanLogo-e755d38491963e3eea245c9cebdfac0e.png";